// lib/components/clickable-table-row/clickable-table-row/clickable-table-row.tsx
import classNames from "classnames";
import React from "react";
import { jsx } from "@emotion/react/jsx-runtime";
var ClickableTableRow = React.forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(
    "tr",
    {
      ...props,
      ref,
      className: classNames(props.className, "is-clickable")
    }
  );
});
ClickableTableRow.displayName = "ClickableTableRow";

export {
  ClickableTableRow
};
